import React from "react";
import { Spinner } from "react-bootstrap";
import "./ComponentLoader.css";

const ComponentLoader = ({ children, show = false }) => {
  return (
    <>
      {!show ? (
        children
      ) : (
        <div className={"component-spinner-container"}>
          {children}
          <div className="component-spinner">
            <Spinner animation="border" variant="danger" />
          </div>
        </div>
      )}
    </>
  );
};

export default ComponentLoader;
